import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {OLD_MODEL_REGISTRY_PROJECT_NAME} from '../../../util/artifacts';
import {
  Banner,
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../Banner';
import {useIsModelRegistryMigrationNotificationEnabled} from './hooks';

type PreMigrationWarningBannerProps = {
  entityName?: string;
  projectName?: string;
  className?: string;
  allTeams?: boolean;
};

export const PreMigrationWarningBanner = ({
  entityName,
  projectName,
  className,
  allTeams = false,
}: PreMigrationWarningBannerProps) => {
  const {enableMRMigrationNotification} =
    useIsModelRegistryMigrationNotificationEnabled();

  if (
    !enableMRMigrationNotification ||
    projectName !== OLD_MODEL_REGISTRY_PROJECT_NAME
  ) {
    return null;
  }
  return (
    <Tailwind>
      <Banner className={className} variant="announcement">
        <BannerFlexWrapper>
          <div>
            <Icon name="warning" />
          </div>
          <BannerTextWrapper>
            {allTeams ? (
              <span>
                <BannerBoldText>
                  Heads up - We're migrating your team model registries.
                </BannerBoldText>{' '}
                The legacy model registries and their collections will soon be
                moved to a new W&B Registry, with the same access and settings.
                No action needed on your part.
              </span>
            ) : (
              <span>
                <BannerBoldText>
                  Heads up - We're migrating this registry.
                </BannerBoldText>{' '}
                This legacy model registry and its collections will soon be
                moved to a new W&B Registry, with the same access and settings.
                No action needed on your part.
              </span>
            )}
          </BannerTextWrapper>
        </BannerFlexWrapper>
      </Banner>
    </Tailwind>
  );
};
